module.exports = "/_next/static/images/british_airways-12e911963d5e2dd7a9514329e7ba9ec1.svg";